module.exports = __webpack_public_path__ + "img/silver.9f53adb6.png";